import { Injectable } from '@angular/core';

const TOKEN_KEY = 'customer_portal_access_token';
const SESSION_KEY = 'customer_portal_browser_session_id';
const PORTAL_ACCESS_ID_KEY = 'customer_portal_access_id';
const TENANT_COMPANY_ID_KEY = 'customer_portal_tenant_company_id';

export interface PortalScopeSelection {
  accessId?: number | null;
  tenantCompanyId?: number | null;
}

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  getAccessToken(): string | null {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  saveAccessToken(token: string): void {
    sessionStorage.setItem(TOKEN_KEY, token);
  }

  savePortalScope(selection: PortalScopeSelection): void {
    const accessId = this.normalizeNumber(selection.accessId);
    const tenantCompanyId = this.normalizeNumber(selection.tenantCompanyId);

    if (accessId != null) {
      sessionStorage.setItem(PORTAL_ACCESS_ID_KEY, String(accessId));
    } else {
      sessionStorage.removeItem(PORTAL_ACCESS_ID_KEY);
    }

    if (tenantCompanyId != null) {
      sessionStorage.setItem(TENANT_COMPANY_ID_KEY, String(tenantCompanyId));
    } else {
      sessionStorage.removeItem(TENANT_COMPANY_ID_KEY);
    }
  }

  getPortalScope(): PortalScopeSelection {
    return {
      accessId: this.parseNumber(sessionStorage.getItem(PORTAL_ACCESS_ID_KEY)),
      tenantCompanyId: this.parseNumber(sessionStorage.getItem(TENANT_COMPANY_ID_KEY))
    };
  }

  clearPortalScope(): void {
    sessionStorage.removeItem(PORTAL_ACCESS_ID_KEY);
    sessionStorage.removeItem(TENANT_COMPANY_ID_KEY);
  }

  clear(): void {
    sessionStorage.removeItem(TOKEN_KEY);
    this.clearPortalScope();
  }

  ensureBrowserSessionId(): string {
    let value = sessionStorage.getItem(SESSION_KEY);
    if (!value) {
      value = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, value);
    }
    return value;
  }

  private parseNumber(value: string | null): number | null {
    if (!value) {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  private normalizeNumber(value: number | null | undefined): number | null {
    return typeof value === 'number' && Number.isFinite(value) ? value : null;
  }
}
